/** 客戶管理路由 */
import Layout from '@/views/layout/customerLayout'

const customerRouter = {
  path: '/crm',
  component: Layout,
  redirect: '/crm/workbench',
  name: 'crm',
  hidden: true,
  meta: {
    requiresAuth: true,
    title: '客戶管理',
    index: 0,
    type: 'crm'
  },
  children: [{
    path: 'workbench', // 工作臺
    component: () => import('@/views/customermanagement/workbench/workbench'),
    meta: {
      requiresAuth: false,
      title: '儀表盤',
      icon: 'dashboard'
    }
  },
  {
    path: 'message', // 待辦事項
    component: () => import('@/views/customermanagement/message/Message'),
    meta: {
      requiresAuth: false,
      title: '待辦事項',
      icon: 'message',
      num: 0
    }
  },
  {
    path: 'clue', // 線索列表
    component: () => import('@/views/customermanagement/clue/ClueIndex'),
    meta: {
      requiresAuth: true,
      title: '線索',
      icon: 'leads',
      index: 1,
      type: 'crm',
      subType: 'leads'
    }
  },
  {
    path: 'customer', // 客戶列表
    component: () => import('@/views/customermanagement/customer/CustomerIndex'),
    meta: {
      requiresAuth: true,
      title: '客戶',
      icon: 'customer',
      index: 1,
      type: 'crm',
      subType: 'customer'
    }
  },
  {
    path: 'contacts', // 聯繫人列表
    component: () => import('@/views/customermanagement/contacts/ContactsIndex'),
    meta: {
      requiresAuth: true,
      title: '聯繫人',
      icon: 'contacts',
      index: 1,
      type: 'crm',
      subType: 'contacts'
    }
  },
  {
    path: 'seas', // 公海列表
    component: () => import('@/views/customermanagement/seas/SeasIndex'),
    meta: {
      requiresAuth: true,
      title: '公海',
      icon: 'seas',
      index: 2,
      type: 'crm',
      subType: ['customer', 'pool']
    }
  },
  {
    path: 'business', // 商機列表
    name: 'business',
    component: () => import('@/views/customermanagement/business/BusinessIndex'),
    meta: {
      requiresAuth: true,
      title: '商機',
      icon: 'business',
      index: 1,
      type: 'crm',
      subType: 'business'
    }
  },
  {
    path: 'contract', // 合同列表
    component: () => import('@/views/customermanagement/contract/ContractIndex'),
    meta: {
      requiresAuth: true,
      title: '合同',
      icon: 'contract',
      index: 1,
      type: 'crm',
      subType: 'contract'
    }
  },
  {
    path: 'money', // 回款列表
    component: () => import('@/views/customermanagement/money/MoneyIndex'),
    meta: {
      requiresAuth: true,
      title: '回款',
      icon: 'money',
      index: 1,
      type: 'crm',
      subType: 'receivables'
    }
  },
  {
    path: 'product', // 產品列表
    component: () => import('@/views/customermanagement/product/ProductIndex'),
    meta: {
      requiresAuth: true,
      title: '產品',
      icon: 'product',
      index: 1,
      type: 'crm',
      subType: 'product'
    }
  }
  ]
}

export default customerRouter
